import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container maxWidth-sm" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "missing-audio-error",
  style: {"color":"red","display":"none"}
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "infoNumber" }
const _hoisted_13 = ["innerHTML"]

import { ref, computed } from "vue";

// eslint-disable-next-line import/no-unresolved
import { Dictionary } from "vue-router/types/router";
import { debug as d } from "debug";
import RenderWaiter from "../../services/utilities/render-waiter";

import HeadFromModel from "../head/head-from-model.vue";
import TeamEffectivenessHeadWithInfo from "../head/team-effectiveness-head-with-info.vue";
import TeamEffectivenessHeadsBreakdown from "../head/team-effectiveness-heads-breakdown.vue";
import TeamEffectivenessBarGraph from "../team-effectiveness/team-effectiveness-bar-graph.vue";
import CherishPieChartReportVisual from "../team-effectiveness/cherish-pie-chart-report-visual.vue";
import CherishBarChartReportVisual from "../team-effectiveness/cherish-bar-chart-report-visual.vue";
import ChangePieChartReportVisual from "../team-effectiveness/change-pie-chart-report-visual.vue";
import ChangeBarChartReportVisual from "../team-effectiveness/change-bar-chart-report-visual.vue";
import CustomSoloBarGraph from "../custom-reports/custom-solo-bar-graph.vue";
import CustomViewpointsBarGraph from "../custom-reports/custom-viewpoints-bar-graph.vue";

// eslint-disable-next-line import/extensions, import/no-unresolved
import ListenActivity from "./listen-activity.vue";
import CollapsedSection from "./collapsed-section.vue";
import LibraryItemLink from "./library-item-link.vue";
import SelfReviewActivity from "./self-review-activity.vue";
import {
  CmsDevelopPage,
  CmsSlice,
  isMandatoryActivity,
  sliceToActivityId,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import CmsExcerpt from "./cms-excerpt.vue";
import CmsQuote from "./cms-quote.vue";
import CmsVideoPlayer from "./cms-video-player.vue";
import CompositeAdhocGroupHead from "../head/composite-adhoc-group-head.vue";
import CmsTextRenderer from "./cms-text-renderer.vue";

const step = null;


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-body',
  props: {
    cmsPage: {},
    context: { default: undefined },
    completedActivityIds: { default: () => [] }
  },
  emits: ["activity-completed", "self-review-completed"],
  setup(__props: any, { emit: __emit }) {

const debug = d("cs.CmsBodyComponent");

const props = __props;

const emit = __emit;

const renderWaits = ref([]);
const renderWaiter = new RenderWaiter(renderWaits.value);

const sections = computed(() => {
  let section = {
    id: "",
    slices: [] as CmsSlice[],
  };
  const sectionsComputed = [section];

  props.cmsPage.data.body.forEach((slice) => {
    if (slice.slice_type !== "cms-section") {
      section.slices.push(slice);
    } else {
      if (!(sectionsComputed.length === 1 && section.slices.length === 0)) {
        section = { id: "", slices: [] };
        sectionsComputed.push(section);
      }
      section.id = slice.primary.id ?? "";
    }
  });

  return sectionsComputed;
});

const pageId = computed(() => props.cmsPage.id);

const pageUid = computed(() => props.cmsPage.uid);

const contentIsLoaded = computed(() => {
  const newValue = !!props.cmsPage && renderWaits.value.length === 0;
  debug("contentIsLoaded: {newValue}");
  return newValue;
});

const numberOfWaits = computed(() => renderWaits.value.length);

const activityId = (slice: CmsSlice): string => {
  return sliceToActivityId(slice, pageId.value);
};

const isMandatoryActivityLocal = (slice: CmsSlice): boolean => {
  return isMandatoryActivity(slice);
};

const isActivityComplete = (slice: CmsSlice): boolean => {
  const id = activityId(slice);
  return props.completedActivityIds.includes(id);
};

const handleActivityCompleted = (completedActivityId: string): void => {
  emit("activity-completed", completedActivityId);
};

const handleSelfReviewCompleted = (completedActivityId: string, answers: number[]): void => {
  emit("self-review-completed", completedActivityId, answers);
};
const cmsInstance = cms;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["cms-body", { loading: !contentIsLoaded.value }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section, sectionIndex) => {
      return (_openBlock(), _createElementBlock("section", {
        class: "cms-section",
        key: sectionIndex
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.slices, (slice, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (slice.slice_type === 'cms-text-block')
                ? (_openBlock(), _createBlock(CmsTextRenderer, {
                    key: index,
                    class: _normalizeClass(["cms-text-block-inner", slice.slice_label]),
                    html: _unref(cms).asHtml(slice.primary.content)
                  }, null, 8, ["class", "html"]))
                : (slice.slice_type === 'cms-collapsed-section')
                  ? (_openBlock(), _createBlock(CollapsedSection, {
                      key: `collapsed-section-${index}`,
                      showDoneButton: !!slice.primary.show_done_button
                    }, {
                      "text-above": _withCtx(() => [
                        _createElementVNode("div", {
                          innerHTML: _unref(cms).asHtml(slice.primary.text_above)
                        }, null, 8, _hoisted_2)
                      ]),
                      "text-below": _withCtx(() => [
                        _createElementVNode("div", {
                          innerHTML: _unref(cms).asHtml(slice.primary.text_below)
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 2
                    }, 1032, ["showDoneButton"]))
                  : (slice.slice_type === 'cms-horizontal-rule')
                    ? (_openBlock(), _createElementBlock("hr", {
                        key: `horizontal-${index}`,
                        class: _normalizeClass([
              'hr-magazine-' + slice.primary.thickness,
              'hr-magazine-' + slice.primary.align,
            ])
                      }, null, 2))
                    : (slice.slice_type === 'cms-text-excerpt')
                      ? (_openBlock(), _createBlock(CmsExcerpt, {
                          key: `text-excerpt-${index}`,
                          slice: slice
                        }, null, 8, ["slice"]))
                      : (slice.slice_type === 'cms-quote-embed')
                        ? (_openBlock(), _createBlock(CmsQuote, {
                            key: `quote-embed-${index}`,
                            slice: slice,
                            renderWaiter: _unref(renderWaiter)
                          }, null, 8, ["slice", "renderWaiter"]))
                        : (slice.slice_type === 'cms-audio-player')
                          ? (_openBlock(), _createBlock(ListenActivity, {
                              activityId: activityId(slice),
                              key: _unref(cms).asText(slice.primary.caption_text),
                              mandatory: _unref(isMandatoryActivity)(slice),
                              complete: isActivityComplete(slice),
                              "cms-audio-src": slice.primary.clip.url,
                              "track-title": _unref(cms).asText(slice.primary.caption_text),
                              "album-title": "Gyre",
                              activityIds: '',
                              onActivityCompleted: handleActivityCompleted
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  innerHTML: _unref(cms).asHtml(slice.primary.caption_title)
                                }, null, 8, _hoisted_4),
                                _createElementVNode("span", {
                                  innerHTML: _unref(cms).asHtml(slice.primary.caption_text)
                                }, null, 8, _hoisted_5),
                                (!slice.primary.clip.url)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "MISSING AUDIO FILE"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["activityId", "mandatory", "complete", "cms-audio-src", "track-title"]))
                          : (slice.slice_type === 'cms-library-item-link')
                            ? (_openBlock(), _createBlock(LibraryItemLink, {
                                key: slice.primary.link.uid,
                                dayOrPageType: (slice.primary.link.data || {}).day_or_page_type,
                                activityId: activityId(slice),
                                mandatory: _unref(isMandatoryActivity)(slice),
                                complete: isActivityComplete(slice),
                                pageId: slice.primary.link.id,
                                pageUid: slice.primary.link.uid
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    innerHTML: _unref(cms).asHtml(slice.primary.caption_title)
                                  }, null, 8, _hoisted_7),
                                  _createElementVNode("span", {
                                    innerHTML: _unref(cms).asHtml(slice.primary.caption_text)
                                  }, null, 8, _hoisted_8),
                                  (!slice.primary.link.id)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "MISSING LINK"))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["dayOrPageType", "activityId", "mandatory", "complete", "pageId", "pageUid"]))
                            : (
              slice.slice_type === 'cms-self-review-activity' && _ctx.cmsPage.type === 'cms-develop-page'
            )
                              ? (_openBlock(), _createBlock(SelfReviewActivity, {
                                  key: `self-review-${index}`,
                                  activityId: activityId(slice),
                                  mandatory: _unref(isMandatoryActivity)(slice),
                                  complete: isActivityComplete(slice),
                                  pageId: pageId.value,
                                  pageUid: pageUid.value,
                                  "develop-page-doc": _ctx.cmsPage,
                                  onSelfReviewCompleted: handleSelfReviewCompleted
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _unref(cms).asHtml(slice.primary.caption_title)
                                    }, null, 8, _hoisted_10),
                                    (_unref(cms).asText(slice.primary.caption_text))
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          innerHTML: _unref(cms).asHtml(slice.primary.caption_text)
                                        }, null, 8, _hoisted_11))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["activityId", "mandatory", "complete", "pageId", "pageUid", "develop-page-doc"]))
                              : (slice.slice_type === 'cms-video-player')
                                ? (_openBlock(), _createBlock(CmsVideoPlayer, {
                                    key: `video-player-${index}`,
                                    mediaSource: slice.primary.media_link.url
                                  }, null, 8, ["mediaSource"]))
                                : (slice.slice_type === 'cms-report-list')
                                  ? (_openBlock(), _createElementBlock("ol", {
                                      key: `report-list-${index}`,
                                      class: "infoNumberList sevenThingsToKnow"
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slice.items, (item, li) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: li,
                                          class: _normalizeClass('li' + (li + 1))
                                        }, [
                                          _createElementVNode("div", _hoisted_12, _toDisplayString(li + 1), 1),
                                          _createElementVNode("div", {
                                            innerHTML: _unref(cms).asHtml(item.report_list_text)
                                          }, null, 8, _hoisted_13)
                                        ], 2))
                                      }), 128))
                                    ]))
                                  : (slice.slice_type === 'cms-report-visual')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: `report-visual-${index}`
                                      }, [
                                        (slice.primary.report_visual_type === 'TeamEffectivenessBreakdown')
                                          ? (_openBlock(), _createBlock(TeamEffectivenessHeadsBreakdown, {
                                              key: 0,
                                              reviewId: _ctx.context['review'].id
                                            }, null, 8, ["reviewId"]))
                                          : (slice.primary.report_visual_type.includes('Info'))
                                            ? (_openBlock(), _createBlock(TeamEffectivenessHeadWithInfo, {
                                                key: 1,
                                                reviewId: _ctx.context['review'].id
                                              }, null, 8, ["reviewId"]))
                                            : (
                slice.primary.report_visual_type !== 'GroupCompositeHead' &&
                (slice.primary.report_visual_type.includes('Head') ||
                  slice.primary.report_visual_type.includes('Diamond'))
              )
                                              ? (_openBlock(), _createBlock(HeadFromModel, {
                                                  key: 2,
                                                  headId: _ctx.context['review'].id,
                                                  kind: slice.primary.report_visual_type,
                                                  style: {"max-width":"40%","margin":"0 auto"}
                                                }, null, 8, ["headId", "kind"]))
                                              : (slice.primary.report_visual_type === 'TeamEffectivenessBarGraph')
                                                ? (_openBlock(), _createBlock(TeamEffectivenessBarGraph, {
                                                    key: 3,
                                                    reviewId: _ctx.context['review'].id
                                                  }, null, 8, ["reviewId"]))
                                                : (slice.primary.report_visual_type === 'CustomSoloBarGraph')
                                                  ? (_openBlock(), _createBlock(CustomSoloBarGraph, { key: 4 }))
                                                  : (slice.primary.report_visual_type === 'CustomViewpointsBarGraph')
                                                    ? (_openBlock(), _createBlock(CustomViewpointsBarGraph, { key: 5 }))
                                                    : (slice.primary.report_visual_type === 'TeamEffectivenessCherishPieChart')
                                                      ? (_openBlock(), _createBlock(CherishPieChartReportVisual, {
                                                          key: 6,
                                                          reviewId: _ctx.context['review'].id
                                                        }, null, 8, ["reviewId"]))
                                                      : (slice.primary.report_visual_type === 'TeamEffectivenessCherishBarChart')
                                                        ? (_openBlock(), _createBlock(CherishBarChartReportVisual, {
                                                            key: 7,
                                                            reviewId: _ctx.context['review'].id
                                                          }, null, 8, ["reviewId"]))
                                                        : (slice.primary.report_visual_type === 'TeamEffectivenessChangePieChart')
                                                          ? (_openBlock(), _createBlock(ChangePieChartReportVisual, {
                                                              key: 8,
                                                              reviewId: _ctx.context['review'].id
                                                            }, null, 8, ["reviewId"]))
                                                          : (slice.primary.report_visual_type === 'TeamEffectivenessChangeBarChart')
                                                            ? (_openBlock(), _createBlock(ChangeBarChartReportVisual, {
                                                                key: 9,
                                                                reviewId: _ctx.context['review'].id
                                                              }, null, 8, ["reviewId"]))
                                                            : (slice.primary.report_visual_type === 'GroupCompositeHead')
                                                              ? (_openBlock(), _createBlock(CompositeAdhocGroupHead, { key: 10 }))
                                                              : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ])
      ]))
    }), 128))
  ], 2))
}
}

})